// Creator approval: which creators are "waiting for approval" and which statuses Approve and
// Reject set. The server's GET /creators/pending-review/count (API v1.1) returns the definition,
// and pendingCreatorsService.getReviewConfig() prefers it; these values are the fallback for a
// server without that endpoint. Components never hardcode these values.

export const PENDING_CREATOR_STATUSES = Object.freeze(['NeedsToSet', 'BrikctoRecruit', 'Not Set', 'In Reviewing']);

// A creator with no status at all is also waiting for a decision.
export const PENDING_INCLUDES_MISSING = true;

// Creators who signed up themselves through the creator portal.
export const PORTAL_SOURCE = 'creator-portal-onboarding';

export const REVIEW_DECISION_STATUS = Object.freeze({
  approve: 'Approved',
  reject: 'Not Strong Enough' // TBD with Laza: the status a rejected creator should get.
});

// POST /creators/:id/review rejects longer notes.
export const REVIEW_NOTE_MAX = 2000;

// Key the count endpoint uses for a missing status or source, and its label.
export const UNSET_KEY = 'unset';
export const UNSET_STATUS_LABEL = 'No status';

// `reviewError` on errors thrown by pendingCreatorsService review calls.
// notFound is also the `code` the server sends on a 404 for an unknown or archived creator.
export const REVIEW_ERROR = Object.freeze({ alreadyReviewed: 'already_reviewed', notFound: 'creator_not_found', invalidId: 'invalid_id', invalidStatus: 'invalid_status' });

// Same shape as getReviewConfig(): used when the server does not send its own definition.
export const DEFAULT_REVIEW_CONFIG = Object.freeze({
  pendingStatuses: PENDING_CREATOR_STATUSES,
  includesMissing: PENDING_INCLUDES_MISSING,
  approveStatus: REVIEW_DECISION_STATUS.approve,
  rejectStatus: REVIEW_DECISION_STATUS.reject,
  fromServer: false
});

export const decisionStatus = (decision, config = DEFAULT_REVIEW_CONFIG) => (
  decision === 'approve' ? config.approveStatus : decision === 'reject' ? config.rejectStatus : undefined
);

// Status filter value for "Waiting for approval" in the creator directory.
export const PENDING_FILTER_VALUE = '__pending__';
export const PENDING_FILTER_LABEL = 'Waiting for approval';

const hasStatus = status => typeof status === 'string' && status.trim() !== '';

export const isPendingStatus = (status, config = DEFAULT_REVIEW_CONFIG) => (
  hasStatus(status) ? config.pendingStatuses.includes(status) : config.includesMissing
);

export const isPendingCreator = (creator, config = DEFAULT_REVIEW_CONFIG) => (
  Boolean(creator) && typeof creator === 'object' && isPendingStatus(creator.status, config)
);

export const isPortalCreator = creator => creator?.source === PORTAL_SOURCE;

// Directory status filter: one exact status, or the pending group.
export const matchesCreatorStatusFilter = (creator, filterStatus) => (
  filterStatus === PENDING_FILTER_VALUE ? isPendingCreator(creator) : creator?.status === filterStatus
);
